import { render, staticRenderFns } from "./TrainerGuide.vue?vue&type=template&id=6b089fea&scoped=true&"
import script from "./TrainerGuide.vue?vue&type=script&lang=js&"
export * from "./TrainerGuide.vue?vue&type=script&lang=js&"
import style0 from "./TrainerGuide.vue?vue&type=style&index=0&id=6b089fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b089fea",
  null
  
)

component.options.__file = "TrainerGuide.vue"
export default component.exports